<template>
  <div class="group-list">
    <section
      v-if="menu.MenuType === 'M' && toppingGroups && toppingGroups.length > 0"
      v-for="(toppingGroup, index) in toppingGroups"
      :id="`subMenu${index}`"
      :key="toppingGroup.GroupCode"
      class="group-item"
    >
      <MenuOptionGroup
        :menu-item-code="menu.ItemCode"
        :menu-type="menu.MenuType"
        :menu-tax2-used="menu.IsTax2"
        :group-code="toppingGroup.GroupCode"
        :group-name="getNameByLocale(toppingGroup)"
        :min-count="toppingGroup.MinCount"
        :max-count="toppingGroup.MaxCount"
        :column-count="columnCount"
        @change="(value) => handleOptionChange(toppingGroup.GroupCode, value)"
      />
    </section>
    <section
      v-else-if="menu.MenuType === 'S' && setMenuGroups && setMenuGroups.length > 0"
      v-for="(setMenuGroup, index) in setMenuGroups"
      :id="`subMenu${index}`"
      :key="setMenuGroup.GroupCode"
      class="group-item"
    >
      <MenuOptionGroup
        :menu-item-code="menu.ItemCode"
        :menu-type="menu.MenuType"
        :menu-tax2-used="menu.IsTax2"
        :group-code="setMenuGroup.GroupCode"
        :group-name="getNameByLocale(setMenuGroup)"
        :min-count="1"
        :max-count="1"
        :column-count="columnCount"
        @change="(value) => handleOptionChange(setMenuGroup.GroupCode, value)"
      />
    </section>
  </div>
</template>

<script setup lang="ts">
  import MenuOptionGroup from '@/components/MenuOptionGroup.vue';
  import CartMenuOption from '@/interfaces/CartMenuOption';
  import Menu from '@/interfaces/Menu';
  import SetMenuGroup from '@/interfaces/SetMenuGroup';
  import ToppingGroup from '@/interfaces/ToppingGroup';
  import { getNameByLocale } from '@/utils';

  interface Props {
    menu: Menu;
    toppingGroups: ToppingGroup[];
    setMenuGroups: SetMenuGroup[];
    columnCount: number;
  }
  defineProps<Props>();

  const emit = defineEmits(['change']);

  const handleOptionChange = (groupCode: string | number, value: CartMenuOption[]) => {
    emit('change', groupCode, value);
  };
</script>

<style lang="scss" scoped>
  .group-list {
    display: flex;
    flex-direction: column;
    gap: 4.2388vw;
  }
</style>
